import { CreditorStatusTypes } from "./CreditorStatusTypes";

export const MAIN_SEARCH_DEFAULT_FILTERS = {
  isOpenCase: true,
  isNextDueDateCase: true,
  isCloseCase: true,
  isCourtCase: true,
  isSentenceCase: true,
  caseNumber: "",
  invoiceNumber: "",
  mainAmount: "",
  balance: "",
  debtorNameNo: "",
  birthdate: "",
  creditorNameNo: "",
  phone: "",
  address: "",
  lastMsgActivityName: "",
  creditorStatus: CreditorStatusTypes.ACTIVE,
  creditorGroupIdName: "",
  custId: "",
  arNo: "",
  additionalReference1: "",
  additionalReference2: "",
};

export enum FilterCriteriasEnum {
  CBX_OPEN,
  CBX_SENTENCE,
  CBX_NEXT_DUE_DATE,
  CBX_COURT,
  CBX_CLOSE,
  INPUT_CASE_NUMBER,
  INPUT_INVOICE_NUMBER,
  INPUT_MAIN_AMOUNT,
  INPUT_BALANCE,
  INPUT_DEBTOR_NAME_NUMBER,
  DATEPICK_BIRTHDATE,
  INPUT_CREDITOR_NAME_NUMBER,
  INPUT_PHONE,
  INPUT_ADDRESS,
  INPUT_LAST_MESSAGE_ACTIVITY,
  SELECT_CREDITOR_STATUS,
  INPUT_CREDITOR_GROUP,
  INPUT_DEBTOR_CUSTID,
  INPUT_DEBTOR_ARNO,
}

export enum PaginationDirection {
  NEXT,
  PREV,
  RESET,
}

export enum SortOrderType {
  "ASC",
  "DESC",
}
